<template>
  <el-table
    border
    :data="tableRows"
    :height="tableHeight"
    v-loading="loading"
    :row-class-name="tableRowClassName"
  >
    <el-table-column :label="rowLabel" :prop="rowLabelProp" min-width="120px" fixed="left"></el-table-column>

    <template v-if="showRing">
      <template v-for="(item, index) in monthItems">
        <el-table-column
          :key="`ring-actual-${index}`"
          :label="`${formatMonth(item.ringActualMonth)}实销`"
          width="100px"
          align="right"
        >
          <template slot-scope="scope">
            {{ getMonthValue(scope.row, index, 'ringActualSales') }}
          </template>
        </el-table-column>
        <el-table-column
          :key="`ring-estimate-${index}`"
          :label="`${formatMonth(item.planMonth)}预估`"
          width="100px"
          align="right"
        >
          <template slot-scope="scope">
            {{ getMonthValue(scope.row, index, 'estimate') }}
          </template>
        </el-table-column>
        <el-table-column
          :key="`ring-rate-${index}`"
          label="环比浮动"
          width="100px"
          align="right"
        >
          <template #header>
            <el-tooltip content="(预估-环比基准实销)/环比基准实销" placement="top">
              <span>环比浮动</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span :style="{ color: rateColor(getMonthValue(scope.row, index, 'ringRate')) }">
              {{ formatRate(getMonthValue(scope.row, index, 'ringRate')) }}
            </span>
          </template>
        </el-table-column>
      </template>
    </template>

    <template v-if="showYoy">
      <template v-for="(item, index) in monthItems">
        <el-table-column
          :key="`yoy-actual-${index}`"
          :label="`${formatMonth(item.yoyActualMonth)}实销`"
          width="100px"
          align="right"
        >
          <template slot-scope="scope">
            {{ getMonthValue(scope.row, index, 'yoyActualSales') }}
          </template>
        </el-table-column>
        <el-table-column
          :key="`yoy-estimate-${index}`"
          :label="`${formatMonth(item.planMonth)}预估`"
          width="100px"
          align="right"
        >
          <template slot-scope="scope">
            {{ getMonthValue(scope.row, index, 'estimate') }}
          </template>
        </el-table-column>
        <el-table-column
          :key="`yoy-rate-${index}`"
          label="同比浮动"
          width="100px"
          align="right"
        >
          <template #header>
            <el-tooltip content="(预估-同比基准实销)/同比基准实销" placement="top">
              <span>同比浮动</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span :style="{ color: rateColor(getMonthValue(scope.row, index, 'yoyRate')) }">
              {{ formatRate(getMonthValue(scope.row, index, 'yoyRate')) }}
            </span>
          </template>
        </el-table-column>
      </template>
    </template>
  </el-table>
</template>

<script>
export default {
  name: 'PreSaleSummaryTable',
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    summary: {
      type: Object,
      default: () => ({})
    },
    compareType: {
      type: String,
      default: 'ALL'
    },
    rowLabel: {
      type: String,
      required: true
    },
    rowLabelProp: {
      type: String,
      required: true
    },
    tableHeight: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showRing() {
      return this.compareType !== 'YOY'
    },
    showYoy() {
      return this.compareType !== 'MOM'
    },
    summaryRow() {
      if (this.summary && this.summary.monthItems && this.summary.monthItems.length) {
        return this.summary
      }
      return this.rows.find(item => item.totalRow)
    },
    tableRows() {
      const rows = this.rows.filter(item => !item.totalRow)
      return this.summaryRow ? [this.summaryRow, ...rows] : this.rows
    },
    monthItems() {
      if (this.summaryRow && this.summaryRow.monthItems && this.summaryRow.monthItems.length) {
        return this.summaryRow.monthItems
      }
      if (this.rows.length && this.rows[0].monthItems && this.rows[0].monthItems.length) {
        return this.rows[0].monthItems
      }
      return []
    }
  },
  methods: {
    getMonthValue(row, index, field) {
      if (!row || !row.monthItems || !row.monthItems[index]) {
        return ''
      }
      return row.monthItems[index][field]
    },
    formatMonth(value) {
      if (!value) {
        return ''
      }
      const month = String(value)
      if (/^\d{6}$/.test(month)) {
        return `${month.substring(2, 4)}年${Number(month.substring(4))}月`
      }
      if (/^\d{4}-\d{2}$/.test(month)) {
        return `${month.substring(2, 4)}年${Number(month.substring(5))}月`
      }
      return month
    },
    formatRate(value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const rate = Number(value)
      if (isNaN(rate)) {
        return ''
      }
      return `${(rate * 100).toFixed(1).replace(/\.0$/, '')}%`
    },
    rateColor(value) {
      if (value > 0) {
        return '#0bb78e'
      }
      if (value < 0) {
        return '#f56c6c'
      }
      return ''
    },
    tableRowClassName({ row }) {
      return row === this.summaryRow || row.totalRow ? 'summary-row' : ''
    }
  }
}
</script>

<style lang="stylus" scoped>
>>> .summary-row td
  background #f5f7fa
  font-weight bold
</style>
